/* Copyright (c) 2022 Xperi. All Rights Reserved. */

import { Diagnostics } from '@tivocorp/tivo-webapp-loggers';
import { Log } from '../../../../core/logging/Log';
import { ScreenTaskControllerTypes } from '../../../../core/navigation/ScreenTaskControllerTypes';
import { setScreenTaskController } from '../../../screens/screens.reducers';
import { changeClosedCaptionLanguage } from '../../videoplayer.reducers';
import { VuLogger } from '../../../../core/logging';
import { IOverlayDialog } from '../../../overlaydialog/overlaydialogprops';
import { OverlayTypes } from '../../../overlay/OverlayTypes';
import { InfoBannerUtils } from '../../../../views/VideoPlayerUI/FullInfoBanner/EventDescription/InfoBannerUtils';
import { Locale } from '../../../../core/locale/Locale';
import { LocaleKeys } from '../../../../core/locale/LocaleKeys';
import {
    hideOverlayDialog,
    showOverlayDialog,
} from '../../../overlaydialog/overlaydialog.reducers';
import { VideoManager } from '../../../../core/videoplayer';

const TAG = 'subtitleandcclanguageoverlay';

export const showSubtitleAndCCLanguageOverlay = () => (dispatch: Function, getState: Function) => {
    const subtitles = VideoManager.getInstance().getVideoPlayerModel().getTextTrackModel();
    const { airingOffers, offerPreview } = VideoManager.getInstance().getMetadata();
    const dataFormatter = new InfoBannerUtils(airingOffers, offerPreview);
    const audioSubtitlePopupTitle = dataFormatter.getAudioSubtitlePopupTitle();
    if (subtitles.length > 0) {
        const overlayDialogProps: IOverlayDialog = {
            hasDimmer: false,
            hasSeperator: false,
            options: subtitles,
            title: Locale.getString(LocaleKeys.SUBTITLE_OVERLAY_TITLE),
            subtitle: audioSubtitlePopupTitle,
            overlayType: OverlayTypes.SUBTITLE_AND_CC_LANGUAGE,
        };

        dispatch(showOverlayDialog(overlayDialogProps));

        Diagnostics.debug(
            TAG,
            'showSubtitleAndCCLanguageOverlay {screenTaskController: ',
            ScreenTaskControllerTypes.SUBTITLE_AND_CC_LANGUAGE_OVERLAY,
            '}',
        );
        Log.d(
            TAG,
            'showSubtitleAndCCLanguageOverlay {screenTaskController: ',
            ScreenTaskControllerTypes.SUBTITLE_AND_CC_LANGUAGE_OVERLAY,
            '}',
        );
        dispatch(
            setScreenTaskController(ScreenTaskControllerTypes.SUBTITLE_AND_CC_LANGUAGE_OVERLAY),
        );
    }
};

export const onKeyBackSubtitleAndCCLanguageOverlay =
    (calledFromOnLanguageSelect?: boolean) => (dispatch: Function, getState: Function) => {
        const { isOverlayDialogActive } = getState().overlayDialog;

        if (isOverlayDialogActive) {
            dispatch(hideOverlayDialog());
        }

        Diagnostics.debug(
            TAG,
            'onKeyBackSubtitleAndCCLanguageOverlay {screenTaskController: ',
            ScreenTaskControllerTypes.DEFAULT_VIDEO_PLAYER_TASKS,
            '}',
        );
        Log.d(
            TAG,
            'onKeyBackSubtitleAndCCLanguageOverlay {screenTaskController: ',
            ScreenTaskControllerTypes.DEFAULT_VIDEO_PLAYER_TASKS,
            '}',
        );
        if (!calledFromOnLanguageSelect) {
            VuLogger.logUserActionEvent({
                actionName: VuLogger.UserActionEventActionName.SUBTITLE_AND_CC,
                action: VuLogger.UserActionEventAction.CANCEL,
                screen: VuLogger.UserActionEventScreen.OVERLAYS,
                selection: VideoManager.getInstance().getVideoPlayerModel().getCurrentTextTrack(),
            });
        }
        dispatch(setScreenTaskController(ScreenTaskControllerTypes.DEFAULT_VIDEO_PLAYER_TASKS));
    };

export const onKeyOkSubtitleAndCCLanguageOverlay =
    () => (dispatch: Function, getState: Function) => {
        const { isOverlayDialogActive } = getState().overlayDialog;
        const { verticalPosition } = getState().overlayHighlight;

        if (isOverlayDialogActive) {
            dispatch(onLanguageSelect(verticalPosition));
        }
    };

export const onLanguageSelect = (selectedIndex: number) => (dispatch: Function) => {
    dispatch(changeClosedCaptionLanguage(selectedIndex));
    dispatch(onKeyBackSubtitleAndCCLanguageOverlay(true));
};
